var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgField = function SvgField(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 88,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122 7H12v74h110V7ZM14 79V9h51.883v26.069a9.002 9.002 0 0 0 0 17.862V79H14Zm53.883-26.043V79H120V9H67.883v26.043a9.001 9.001 0 0 1 0 17.914Zm0-15.902a7.001 7.001 0 0 1 0 13.89v-13.89Zm-2 .034V50.91a7.002 7.002 0 0 1 0-13.822Z",
    fill: "#FA9900"
  })));
};
export default SvgField;